import type {SpotlightArrowLayout} from '@/sdk-mobile-web/SpotlightMaskedView/types';

export function useArrowPosition(
  passedLayout?: SpotlightArrowLayout,
  ref?: HTMLElement
): SpotlightArrowLayout | undefined {
  if (passedLayout) {
    return {
      width: passedLayout.width,
      height: passedLayout.height,
      rootX: passedLayout.x || passedLayout.rootX,
      rootY: passedLayout.y || passedLayout.rootY,
    };
  }

  if (!ref) {
    return undefined;
  }

  const refRect = ref.getBoundingClientRect();

  return {
    width: refRect.width,
    height: refRect.height,
    rootX: refRect.left,
    rootY: refRect.top,
  };
}
